import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Link } from "react-router-dom";

const tocItems = [
  { id: "services", label: "1. OUR SERVICES" },
  { id: "ip", label: "2. INTELLECTUAL PROPERTY RIGHTS" },
  { id: "userreps", label: "3. USER REPRESENTATIONS" },
  { id: "userreg", label: "4. USER REGISTRATION" },
  { id: "products", label: "5. PRODUCTS" },
  { id: "purchases", label: "6. PURCHASES AND PAYMENT" },
  { id: "returnno", label: "7. RETURN POLICY" },
  { id: "prohibited", label: "8. PROHIBITED ACTIVITIES" },
  { id: "ugc", label: "9. USER GENERATED CONTRIBUTIONS" },
  { id: "license", label: "10. CONTRIBUTION LICENCE" },
  { id: "sitemanage", label: "11. SERVICES MANAGEMENT" },
  { id: "terms", label: "12. TERM AND TERMINATION" },
  { id: "modifications", label: "13. MODIFICATIONS AND INTERRUPTIONS" },
  { id: "law", label: "14. GOVERNING LAW" },
  { id: "disputes", label: "15. DISPUTE RESOLUTION" },
  { id: "corrections", label: "16. CORRECTIONS" },
  { id: "disclaimer", label: "17. DISCLAIMER" },
  { id: "liability", label: "18. LIMITATIONS OF LIABILITY" },
  { id: "indemnification", label: "19. INDEMNIFICATION" },
  { id: "userdata", label: "20. USER DATA" },
  {
    id: "electronic",
    label: "21. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES",
  },
  { id: "misc", label: "22. MISCELLANEOUS" },
  { id: "contact", label: "23. CONTACT US" },
];

export default function TermsOfServicePage() {
  return (
    <>
      <Navbar />
      <div className="policy-page">
        <div className="policy-container">
          <div className="breadcrumb__list mb-30">
            <span>
              <Link to="/">Home</Link>
            </span>
            <span className="dvdr">
              <i className="fa-regular fa-angle-right"></i>
            </span>
            <span>Terms of Service</span>
          </div>
          <header className="policy-header">
            <h1>Terms of Service</h1>
            <p className="policy-updated">
              <strong>Last updated:</strong> January 01, 2026
            </p>
            <p>
              These legal terms apply to <strong>A1 Bakery and Sweets</strong>,
              including the website{" "}
              <a
                href="http://www.a1bakeryandsweets.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.a1bakeryandsweets.com
              </a>
              , and related services.
            </p>
          </header>

          <section className="policy-toc">
            <h2>Table of Contents</h2>
            <ul>
              {tocItems.map((item) => (
                <li key={item.id}>
                  <a href={`#${item.id}`}>{item.label}</a>
                </li>
              ))}
            </ul>
          </section>

          <section className="policy-section">
            <h2>Agreement to Our Legal Terms</h2>
            <p>
              We are <strong>A1 Bakery and Sweets</strong> ("Company", "we",
              "us", or "our"). We operate the website{" "}
              <a
                href="http://www.a1bakeryandsweets.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.a1bakeryandsweets.com
              </a>{" "}
              and any related services governed by these Legal Terms.
            </p>
            <p>
              A1 Bakery and Sweets is a bakery and eCommerce platform offering
              cakes, pastries, snacks, and handcrafted sweets, prepared with
              quality ingredients and hygienic processes, with online ordering
              and delivery support.
            </p>
            <p>
              You can contact us by phone at <strong>9751336638</strong> or by
              email at{" "}
              <a href="mailto:a1foodfactory2008@gmail.com">
                a1foodfactory2008@gmail.com
              </a>
              .
            </p>
            <p>
              By accessing or using the services, users agree to be bound by
              these Legal Terms, and users who do not agree must discontinue use
              immediately.
            </p>
            <p>
              The terms may be updated from time to time, and continued use
              after updates means acceptance of the revised terms.
            </p>
            <p>
              The services are intended for users at least 13 years old, and
              minors generally under 18 must have parent or guardian permission
              and supervision.
            </p>
          </section>

          <section id="services" className="policy-section">
            <h2>1. OUR SERVICES</h2>
            <p>
              The information provided when using the Services is not intended
              for distribution to or use by any person or entity in any
              jurisdiction or country where such distribution or use would be
              contrary to law or regulation or which would subject us to any
              registration requirement within such jurisdiction or country.
            </p>
            <p>
              The Services are intended for use only by persons who are at least
              13 years of age. All users who are minors in the jurisdiction in
              which they reside (generally under 18) must have the permission
              of, and be directly supervised by, their parent or guardian.
            </p>
          </section>

          <section id="ip" className="policy-section">
            <h2>2. INTELLECTUAL PROPERTY RIGHTS</h2>
            <h3>Our intellectual property</h3>
            <p>
              We are the owner or the licensee of all intellectual property
              rights in the Services, including all source code, databases,
              functionality, software, website designs, text, photographs,
              graphics, and the trademarks, service marks, and logos contained
              therein (the "Content").
            </p>
            <p>
              The Content and Marks are protected by copyright, trademark, and
              other intellectual property and unfair competition laws and
              treaties around the world.
            </p>
            <p>
              The Content and Marks are provided "AS IS" for your information
              and personal, non-commercial use only.
            </p>

            <h3>Your use of our Services</h3>
            <p>
              Subject to your compliance with these Legal Terms, you are hereby
              granted a limited, non-exclusive, non-transferable,
              non-sublicensable, revocable license to access and use our
              Services and Content for your own personal, non-commercial use.
            </p>
            <p>
              You shall not copy, reproduce, republish, post, distribute, sell,
              license, or otherwise commercially exploit the Content or Marks
              without our prior written consent.
            </p>

            <h3>Your submissions</h3>
            <p>
              By sending us questions, comments, suggestions, feedback, or other
              submissions, you grant us a non-exclusive, worldwide,
              royalty-free, perpetual, irrevocable, and fully sublicensable
              right to use, reproduce, modify, adapt, publish, translate, create
              derivative works from, distribute, and display throughout the
              world in any media any such submissions.
            </p>
          </section>

          <section id="userreps" className="policy-section">
            <h2>3. USER REPRESENTATIONS</h2>
            <p>
              By using the Services, you represent and warrant that: (1) all
              registration information you submit will be true, accurate,
              current, and complete; (2) you have the legal capacity and agree
              to comply with these Legal Terms; (3) you are not under the age of
              13; (4) you are not a minor or you have received parental
              permission to use the Services; (5) you will not access the
              Services through automated or non-human means, whether through a
              bot, script, or otherwise; (6) you will not use the Services for
              any illegal or unauthorized purpose; and (7) your use of the
              Services will not violate any applicable law or regulation.
            </p>
            <p>
              If you provide any information that is untrue, inaccurate, not
              current, or incomplete, we have the right to suspend or terminate
              your account and refuse any and all current or future use of the
              Services.
            </p>
          </section>

          <section id="userreg" className="policy-section">
            <h2>4. USER REGISTRATION</h2>
            <p>
              You may be required to register to use the Services. You agree to
              keep your registration information accurate and up to date.
            </p>
            <p>
              You are responsible for maintaining the confidentiality of your
              account and password and for restricting access to your account.
              You agree to accept responsibility for all activities that occur
              under your account.
            </p>
            <p>
              We reserve the right to remove, reclaim, or change a username you
              select if we determine, in our sole discretion, that the username
              is inappropriate, obscene, or otherwise objectionable.
            </p>
          </section>

          <section id="products" className="policy-section">
            <h2>5. PRODUCTS</h2>
            <p>
              All products are subject to availability. We reserve the right to
              discontinue any product at any time.
            </p>
            <p>
              All product descriptions are for informational purposes only. We
              make no warranties as to the accuracy of the product descriptions.
            </p>
            <p>
              Product images are for illustrative purposes only. Actual products
              may vary in appearance from the images shown.
            </p>
          </section>

          <section id="purchases" className="policy-section">
            <h2>6. PURCHASES AND PAYMENT</h2>
            <p>
              All purchases made through the Services are final and
              non-refundable except as required by law or as stated in our
              Return Policy.
            </p>
            <p>
              You agree to provide current, complete, and accurate purchase
              information for all purchases made via the Services.
            </p>
            <p>
              We reserve the right to refuse any order you place with us. We
              may, in our sole discretion, limit or cancel quantities purchased
              per person, per household, or per order.
            </p>
          </section>

          <section id="returnno" className="policy-section">
            <h2>7. RETURN POLICY</h2>
            <p>
              Due to the perishable nature of bakery products, all sales are
              final. No returns or refunds will be accepted.
            </p>
            <p>
              If you receive a damaged, incorrect, or defective order, please
              contact us within 2 hours of delivery at
              a1foodfactory2008@gmail.com with photos of the issue.
            </p>
            <p>
              We reserve the right to inspect and approve any refund requests at
              our discretion.
            </p>
          </section>

          <section id="prohibited" className="policy-section">
            <h2>8. PROHIBITED ACTIVITIES</h2>
            <p>
              You may not access or use the Services for any purpose other than
              that for which we make the Services available. The Services may
              not be used in connection with any commercial endeavors except
              those that are specifically endorsed or approved by us.
            </p>
            <p>As a user of the Services, you agree not to:</p>
            <ul>
              <li>
                Systematically retrieve data or other content from the Services
                to create or compile, directly or indirectly, a collection,
                compilation, database, or directory without written permission
                from us.
              </li>
              <li>
                Make any unauthorized use of the Services, including collecting
                usernames and/or email addresses of users by electronic or other
                means for the purpose of sending unsolicited email.
              </li>
              <li>
                Use the Services in a manner inconsistent with any applicable
                laws or regulations.
              </li>
              <li>
                Circumvent, disable, or otherwise interfere with
                security-related features of the Services.
              </li>
            </ul>
          </section>

          <section id="ugc" className="policy-section">
            <h2>9. USER GENERATED CONTRIBUTIONS</h2>
            <p>
              The Services may invite you to chat, contribute to, or participate
              in blogs, message boards, online forums, and other functionality,
              and may provide you with the opportunity to submit, post, display,
              transmit, perform, publish, distribute, or broadcast content and
              materials to us or through the Services, including but not limited
              to text, writings, video, audio, photographs, graphics, comments,
              suggestions, or personal information.
            </p>
          </section>

          <section id="license" className="policy-section">
            <h2>10. CONTRIBUTION LICENCE</h2>
            <p>
              By posting your Contributions to the Services, you automatically
              grant, and you represent and warrant that you have the right to
              grant, to us an unrestricted, unlimited, irrevocable, perpetual,
              non-exclusive, transferable, royalty-free, fully-paid, worldwide
              right to use, copy, reproduce, distribute, sell, resell, and
              further reproduce your Contributions in perpetuity.
            </p>
          </section>

          <section id="sitemanage" className="policy-section">
            <h2>11. SERVICES MANAGEMENT</h2>
            <p>
              We reserve the right, but not the obligation, to: (1) monitor the
              Services for violations of these Legal Terms; (2) take appropriate
              legal action against anyone who, in our sole discretion, violates
              the law or these Legal Terms, including without limitation,
              reporting such user to law enforcement authorities; (3) refuse or
              remove access to the Services from anyone who violates these Legal
              Terms; (4) at our sole discretion and without limitation or
              notice, refuse or remove any Content that is deemed objectionable;
              and (5) at our sole discretion and without limitation or notice,
              refuse or remove any user that is deemed objectionable.
            </p>
          </section>

          <section id="terms" className="policy-section">
            <h2>12. TERM AND TERMINATION</h2>
            <p>
              These Legal Terms shall remain in full force and effect while you
              use the Services. Without limiting any other provision of these
              Legal Terms, we reserve the right to, in our sole discretion and
              without notice or liability, deny access to and use of the
              Services to any person for any reason or for no reason.
            </p>
          </section>

          <section id="modifications" className="policy-section">
            <h2>13. MODIFICATIONS AND INTERRUPTIONS</h2>
            <p>
              We reserve the right to change, modify, or remove the contents of
              the Services at any time or for any reason at our sole discretion
              without notice. We also reserve the right to modify or discontinue
              all or part of the Services without notice at any time.
            </p>
            <p>
              We cannot guarantee the Services will be available 100% of the
              time. We may experience hardware, software, or other problems or
              need to perform maintenance related to the Services, resulting in
              interruptions, delays, or errors.
            </p>
          </section>

          <section id="law" className="policy-section">
            <h2>14. GOVERNING LAW</h2>
            <p>
              These Legal Terms shall be governed by and defined following the
              laws of India and yourself and us irrevocably consent that the
              courts of Madurai shall have exclusive jurisdiction to resolve any
              dispute.
            </p>
          </section>

          <section id="disputes" className="policy-section">
            <h2>15. DISPUTE RESOLUTION</h2>
            <p>
              Any legal action of whatever nature brought by either you or us
              shall be commenced within one (1) year after the claim or cause of
              action is known or should reasonably have been known.
            </p>
          </section>

          <section id="corrections" className="policy-section">
            <h2>16. CORRECTIONS</h2>
            <p>
              There may be information on the Services that contains
              typographical errors, inaccuracies, or omissions. We reserve the
              right to correct any errors, inaccuracies, or omissions and to
              change or update information at any time, without prior notice.
            </p>
          </section>

          <section id="disclaimer" className="policy-section">
            <h2>17. DISCLAIMER</h2>
            <p>
              THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. You
              agree that your use of the Services will be at your sole risk.
            </p>
          </section>

          <section id="liability" className="policy-section">
            <h2>18. LIMITATIONS OF LIABILITY</h2>
            <p>
              IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
              LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
              CONSEQUENTIAL, EXEMPLARY, INCIDENTAL SPECIAL OR PUNITIVE DAMAGES,
              INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER
              DAMAGES ARISING FROM YOUR USE OF THE SERVICES.
            </p>
          </section>

          <section id="indemnification" className="policy-section">
            <h2>19. INDEMNIFICATION</h2>
            <p>
              You agree to defend, indemnify, and hold us harmless, including
              our subsidiaries, affiliates, and all of our respective officers,
              agents, partners, and employees, from and against any loss,
              damage, liability, claim, or demand, including reasonable
              attorneys' fees and expenses.
            </p>
          </section>

          <section id="userdata" className="policy-section">
            <h2>20. USER DATA</h2>
            <p>
              We will maintain certain data that you transmit for the purpose of
              managing the performance of the Services, as well as data relating
              to your use of the Services.
            </p>
          </section>

          <section id="electronic" className="policy-section">
            <h2>21. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</h2>
            <p>
              Visiting the Services, sending us emails, and completing online
              forms constitute electronic communications. By visiting the
              Services, you consent to receive electronic communications, and
              you agree that all agreements, notices, disclosures, and other
              communications we provide to you electronically satisfy any legal
              requirement.
            </p>
          </section>

          <section id="misc" className="policy-section">
            <h2>22. MISCELLANEOUS</h2>
            <p>
              These Legal Terms and any policies or operating rules posted by us
              on the Services constitute the entire agreement between you and
              us.
            </p>
            <p>
              Our failure to exercise or enforce any right or provision of these
              Legal Terms shall not operate as a waiver of such right or
              provision.
            </p>
            <p>
              We may assign any or all of our rights and obligations to others
              at any time.
            </p>
          </section>

          <section id="contact" className="policy-section">
            <h2>23. CONTACT US</h2>
            <p>
              <strong>A1 Bakery and Sweets</strong>
            </p>
            <p>
              Website:{" "}
              <a
                href="http://www.a1bakeryandsweets.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.a1bakeryandsweets.com
              </a>
            </p>
            <p>
              Phone: <strong>9751336638</strong>
            </p>
            <p>
              Email:{" "}
              <a href="mailto:a1foodfactory2008@gmail.com">
                a1foodfactory2008@gmail.com
              </a>
            </p>
            <p>
              Country: <strong>India</strong>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
}
